<script setup lang="ts"></script>

<template>
  <div class="content">
    <div class="left">
      <div class="item">
        <div class="title">
          <span class="t">车</span>
        </div>

        <div class="info">
          <div class="item">
            <div class="t">
              <div class="limit"></div>
              自动驾驶车辆
            </div>
            <div class="txt" style="margin-top: 16px">总共接入数量</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #ffffff">321</div>
            <div class="txt" style="margin-top: 9px">目前实时在线</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #0effca">165</div>
          </div>

          <div class="item">
            <div class="t">
              <div class="limit"></div>
              出租车
            </div>
            <div class="txt" style="margin-top: 16px">总共接入数量</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #ffffff">4040</div>
            <div class="txt" style="margin-top: 9px">目前实时在线</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #0effca">3500</div>
          </div>

          <div class="item" style="align-items: flex-end">
            <div class="t r" style="justify-content: flex-end">
              公交车
              <div class="limit" style="margin-right: 0px; margin-left: 6px"></div>
            </div>
            <div class="txt" style="margin-top: 16px">总共接入数量</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #ffffff">2798</div>
            <div class="txt" style="margin-top: 9px">目前实时在线</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #0effca">1435</div>
          </div>

          <div class="item" style="align-items: flex-end">
            <div class="t r" style="justify-content: flex-end">
              低速装备车
              <div class="limit" style="margin-right: 0px; margin-left: 6px"></div>
            </div>
            <div class="txt" style="margin-top: 16px">总共接入数量</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #ffffff">396</div>
            <div class="txt" style="margin-top: 9px">目前实时在线</div>
            <div class="txt" style="margin-top: 9px; font-size: 24px; color: #0effca">62</div>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <span class="t">能</span>
        </div>

        <div
          class="info"
          style="background-image: none; flex-direction: column; justify-content:flex-start"
        >
          <div class="bgimg">
            <div class="bgtxt">充电站数量</div>
            <div class="bgtxt" style="margin-top: 6px; font-size: 24px; color: #ffffff">1223</div>
          </div>
          <div class="bgimg b2">
            <div class="bgtxt">充电桩数量</div>
            <div class="bgtxt" style="margin-top: 6px; font-size: 24px; color: #ffffff">3467</div>
          </div>
          <div class="bgimg b3">
            <div class="bgtxt">充电枪数量</div>
            <div class="bgtxt" style="margin-top: 6px; font-size: 24px; color: #ffffff">6854</div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="markLine" style="left: 738px; top: 72px">
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" style="height: 200px" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
      </div>

      <div class="markLine" style="left: 1168px; top: 98px">
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" style="height: 200px" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
      </div>

      <div class="markLine" style="left: 738px; top: 392px">
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" style="height: 100px" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" style="height: 200px" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
      </div>

      <div class="markLine" style="left: 899px; top: 162px">
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" style="height: 170px" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
      </div>

      <div class="markLine" style="left: 1106px; top: 282px">
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" style="height: 200px" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
        <div class="item">
          <img src="@/assets/zzt-img-01.png" class="itemtop" />
          <img src="@/assets/zzt-img-02.png" class="itembuttom" />
        </div>
      </div>
    </div>
    <div class="right">
      <div class="item">
        <div class="title">
          <span class="t">路</span>
        </div>

        <div class="info" style="background-image: url('@/assets/mk03-bg-img01.png')">
          <div class="item">
            <div class="t">
              <div class="limit"></div>
              信号机
            </div>
            <div class="txt" style="margin-top: 10px">总共接入数量</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #ffffff">2169</div>
            <div class="txt" style="margin-top: 6px">目前实时在线</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #0effca">2167</div>
          </div>

          <div class="item">
            <div class="t">
              <div class="limit"></div>
              RSU
            </div>
            <div class="txt" style="margin-top: 10px">总共接入数量</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #ffffff">452</div>
            <div class="txt" style="margin-top: 6px">目前实时在线</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #0effca">452</div>
          </div>

          <div class="item" style="align-items: flex-end">
            <div class="t r" style="justify-content: flex-end">
              RFID
              <div class="limit" style="margin-right: 0px; margin-left: 6px"></div>
            </div>
            <div class="txt" style="margin-top: 10px">总共接入数量</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #ffffff">300</div>
            <div class="txt" style="margin-top: 6px">目前实时在线</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #0effca">300</div>
          </div>

          <div class="item" style="align-items: flex-end">
            <div class="t r" style="justify-content: flex-end">
              超眼
              <div class="limit" style="margin-right: 0px; margin-left: 6px"></div>
            </div>
            <div class="txt" style="margin-top: 10px">总共接入数量</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #ffffff">18</div>
            <div class="txt" style="margin-top: 6px">目前实时在线</div>
            <div class="txt" style="margin-top: 6px; font-size: 24px; color: #0effca">15</div>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <span class="t">云</span>
        </div>

        <div
          class="info"
          style="background-image: none; flex-direction: column; justify-content:flex-start;"
        >
          <div class="rbgimg" style="margin-top: 20px">
            <div class="bgtxt" style="margin-top: 44px; font-size: 24px; color: #ffffff">2167</div>
            <div class="bgtxt" style="margin-top: 6px">信号灯数量</div>
          </div>
          <div class="rbgimg rb2">
            <div class="bgtxt" style="margin-top: 44px; font-size: 24px; color: #ffffff">408</div>
            <div class="bgtxt" style="margin-top: 6px">交通事件数</div>
          </div>
          <div class="rbgimg rb3" style="margin-top: 20px">
            <div class="bgtxt" style="margin-top: 30px; font-size: 24px; color: #ffffff">0.27%</div>
            <div class="bgtxt" style="margin-top: 6px">排队数量</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use './index.scss';
</style>
